export default __webpack_public_path__ + "static/media/icon_whats.9ff95f6d.png";